module.exports = __webpack_public_path__ + "img/ico-flag.1c37f5a8.svg";